import type { PeriodoEntrega } from "../../../services/periodoEntregaFornecedor"

export type { PeriodoEntrega }

export type PeriodoEntregaFornecedorModel = {
    periodos: PeriodoEntrega[]
    statusDelivery: number
}

export const PeriodoEntregaFornecedorInicial: PeriodoEntregaFornecedorModel = {
    periodos: [],
    statusDelivery: 0,
}
